import { h } from 'preact'
import './row.css'

const Row = ({
  title,
  width = 4,
  height = 1,
  size = 6,
  children,
  e2e,
  align = 'left'
}) =>
  h(
    'div',
    { className: 'flex f' + size + ' mb' + height, 'data-e2e': e2e || false },
    h(
      'div',
      { className: 'w' + width, style: { flexShrink: 0 } },
      h('span', null, h('strong', null, title))
    ),
    h(
      'div',
      { className: 'fg3' },
      h(
        'div',
        { className: 'v-mid rowBreakWords' + (align === 'right' ? ' tr' : '') },
        children
      )
    )
  )

export default Row
